import { inject, singleton } from "tsyringe";
import { ConsentProviderInterface, Consents } from "@identity/services";
import { WINDOW } from "@identity/symbols";
import { Geo, waitFor } from "@identity/utils";

@singleton()
export class CookieBot implements ConsentProviderInterface {
  consentGiven: Promise<Consents>;
  resolveConsent: (consent: Consents) => void;

  constructor(
    @inject(WINDOW) private window: Window,
    @inject(Geo) private geo: Geo,
  ) {
    this.consentGiven = new Promise((res) => (this.resolveConsent = res));
    this.subscribe();
  }

  subscribe() {
    waitFor(() => !!this.window.Cookiebot).then(() => this.resolve());
  }

  private resolve() {
    this.resolveConsent({
      gdprConsent: this.window.Cookiebot.marketing,
      ccpaSignal: !this.window.Cookiebot.marketing,
      geoRequiresConsent: this.geo.isGdprCountry(),
      geoRequiresSignal: this.geo.getCountryCode() === "us",
    });
  }

  static enabled(): boolean {
    return window.location.hostname.includes("fanatical.com");
  }
}
